/* RONCADOR: compra rapida (igual a Fashion Nova)
   A bolinha da sacola no cartao abre, de baixo para cima, uma mini pagina
   do produto com: fotos, nome, avaliacao, preco, preco de antes, cor e
   tamanho. Escolhido o tamanho, o botao poe no carrinho e abre o carrinho
   lateral (o mesmo caminho do botao da pagina do produto). */
(function () {
  if (window.__rcQA) return;
  window.__rcQA = true;

  var cache = {};
  var raiz = null;
  var atual = null;
  var fechando = null;
  var origem = null;

  function dinheiro(c) {
    return 'R$ ' + (c / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function foto(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }
  function nomeOp(o) {
    return String(typeof o === 'string' ? o : (o && o.name) || '');
  }
  function eCor(n) {
    return /^(cor|cores|color|colour)\b/i.test(n);
  }
  /* bolinha da cor: mesmas cores da pagina de produto (pelo nome) */
  var CORES = [
    [/verde (escuro|musgo|militar)/, '#2f5a34'],
    [/lim[aã]o/, '#9ccf3c'],
    [/preto|black/, '#111111'],
    [/branc|white/, '#f5f5f0'],
    [/marinho|escuro|dark/, '#1f3554'],
    [/stone|estonad/, '#8fb0d3'],
    [/claro/, '#9dbbdc'],
    [/marmor/, '#5f84ad'],
    [/royal/, '#2f56a6'],
    [/azul|jeans|blue/, '#4a72a8'],
    [/cinza|grafite|chumbo|gray|grey/, '#9a9a9a'],
    [/marrom|caf|chocolate|brown/, '#6b4a33'],
    [/bege|caqui|areia|nude|khaki/, '#d9c6a5'],
    [/verde|green/, '#4a8a3e'],
    [/vermelh|vinho|red/, '#b3141c'],
    [/rosa|pink/, '#e88bbd'],
    [/amarel|mostarda/, '#f0d95c'],
    [/laranja/, '#e8994a'],
    [/roxo|lil/, '#8e5bb5']
  ];
  function hexDe(val) {
    var n = String(val).toLowerCase();
    for (var i = 0; i < CORES.length; i++) if (CORES[i][0].test(n)) return CORES[i][1];
    return '#d6d6d6';
  }
  function eTam(n) {
    return /^(tamanho|tamanhos|tam|size)\b/i.test(n);
  }
  function semAcento(s) {
    return s.normalize ? s.normalize('NFD').replace(/[̀-ͯ]/g, '') : s;
  }

  /* ---------- a folha (criada uma vez, fica no body) ---------- */
  function montar() {
    if (raiz && document.body.contains(raiz)) return raiz;
    raiz = document.createElement('div');
    raiz.className = 'rc-qa';
    raiz.hidden = true;
    raiz.innerHTML =
      '<div class="rc-qa__veu" data-rc-qa-fecha></div>' +
      '<div class="rc-qa__folha" role="dialog" aria-modal="true" aria-label="Compra rápida">' +
      '<div class="rc-qa__topo"><p class="rc-qa__topo-tit">Compra rápida</p>' +
      '<button type="button" class="rc-qa__x" data-rc-qa-fecha aria-label="Fechar">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div>' +
      '<div class="rc-qa__corpo" data-rc-qa-corpo></div>' +
      '<div class="rc-qa__tab" data-rc-qa-tab hidden><div class="rc-qa__tab-veu" data-rc-qa-tab-fecha></div><div class="rc-qa__tab-caixa"><div class="rc-qa__topo">' +
      '<p class="rc-qa__topo-tit">Tabela de medidas</p>' +
      '<button type="button" class="rc-qa__x" data-rc-qa-tab-fecha aria-label="Fechar a tabela">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div>' +
      '<div class="rc-qa__tab-corpo" data-rc-qa-tab-corpo></div></div></div>' +
      '</div>';
    document.body.appendChild(raiz);
    raiz.addEventListener('click', clique);
    return raiz;
  }

  function abrir() {
    montar();
    clearTimeout(fechando);
    raiz.hidden = false;
    document.documentElement.classList.add('rc-qa-aberta');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        raiz.classList.add('is-aberta');
      });
    });
  }
  function fechar() {
    if (!raiz || raiz.hidden) return;
    raiz.classList.remove('is-aberta');
    document.documentElement.classList.remove('rc-qa-aberta');
    var tb = raiz.querySelector('[data-rc-qa-tab]');
    if (tb) {
      tb.classList.remove('is-aberta');
      tb.hidden = true;
    }
    fechando = setTimeout(function () {
      raiz.hidden = true;
    }, 420);
  }

  /* ---------- dados do produto ---------- */
  function buscar(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(base + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (p) {
        cache[handle] = p;
        return p;
      });
  }

  /* opcoes que valem a pena mostrar (some com "Title / Default Title") */
  function opcoesDe(p) {
    var lista = [];
    (p.options || []).forEach(function (o, i) {
      var nome = nomeOp(o);
      var valores = [];
      p.variants.forEach(function (v) {
        var val = v.options[i];
        if (valores.indexOf(val) < 0) valores.push(val);
      });
      if (valores.length === 1 && /default title/i.test(valores[0])) return;
      lista.push({ i: i, nome: nome, valores: valores, cor: eCor(nome), tam: eTam(nome) });
    });
    return lista;
  }

  function variantesQueCombinam(sel, ignorar) {
    return atual.p.variants.filter(function (v) {
      return atual.ops.every(function (o) {
        if (o.i === ignorar || sel[o.i] == null) return true;
        return v.options[o.i] === sel[o.i];
      });
    });
  }
  function varianteEscolhida() {
    var falta = atual.ops.some(function (o) {
      return atual.sel[o.i] == null;
    });
    if (falta) return null;
    return variantesQueCombinam(atual.sel, -1)[0] || null;
  }

  /* ---------- desenhar ---------- */
  function desenhar(p, nota, qt) {
    var corpo = raiz.querySelector('[data-rc-qa-corpo]');
    var ops = opcoesDe(p);
    var sel = {};
    var base = p.variants.filter(function (v) {
      return v.available;
    })[0] || p.variants[0];
    ops.forEach(function (o) {
      /* cor (e outras) ja vem marcada; o tamanho a pessoa escolhe */
      if (!o.tam || o.valores.length === 1) sel[o.i] = base.options[o.i];
    });
    atual = { p: p, ops: ops, sel: sel };

    var imgs = (p.images || []).slice(0, 12);
    var h = '<div class="rc-qa__fotos" data-rc-qa-fotos>';
    imgs.forEach(function (src, n) {
      h +=
        '<div class="rc-qa__foto"><img src="' + foto(src, 500) + '" alt="' + esc(p.title) + '"' +
        (n > 2 ? ' loading="lazy"' : '') + ' width="500" height="750"></div>';
    });
    h += '</div>';

    var ref0 = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
    var off = ref0.compare_at_price > ref0.price ? Math.round((1 - ref0.price / ref0.compare_at_price) * 100) : 0;
    h += '<div class="rc-qa__info">';
    h += '<div class="rc-qa__linha1">';
    h += off > 0 ? '<span class="rc-qa__off">' + off + '% OFF</span>' : '<span></span>';
    if (qt > 0) {
      h +=
        '<a class="rc-qa__nota" href="' + esc(p.url) + '#rc-avaliacoes"><span class="rc-qa__estrelas" style="--rc-p:' +
        Math.round((nota / 5) * 100) + '%" aria-hidden="true"></span><span class="rc-qa__qt">(' + qt + ')</span></a>';
    }
    h += '</div>';
    h += '<div class="rc-qa__linha2"><p class="rc-qa__titulo">' + esc(p.title) + '</p>' +
      '<a class="rc-qa__detalhes" href="' + esc(p.url) + '">Ver detalhes</a></div>';
    h += '<div class="rc-qa__preco"><span class="rc-qa__venda" data-rc-qa-venda></span><s class="rc-qa__de" data-rc-qa-de></s></div>';

    var calca = /cal[cç]a/i.test(p.title) && !/feminin/i.test(p.title);
    /* tamanho primeiro, cor depois (igual a Fashion Nova) */
    ops.slice().sort(function (x, y) { return (y.tam ? 1 : 0) - (x.tam ? 1 : 0); }).forEach(function (o) {
      h += '<div class="rc-qa__grupo" data-rc-qa-grupo="' + o.i + '">';
      if (o.tam) {
        h += '<p class="rc-qa__rot"><span data-rc-qa-rot-nome>' + esc(o.nome) + '</span>' +
          (calca ? '<span class="rc-qa__barra">|</span><button type="button" class="rc-qa__tabela" data-rc-qa-tabela="/pages/tabela-de-calcas-masculinas">Ver tabela de medidas</button>' : '') + '</p>';
      } else {
        h += '<p class="rc-qa__rot">' + esc(o.nome) + ': <span data-rc-qa-valor></span></p>';
      }
      h += '<div class="rc-qa__opcoes' + (o.tam ? ' rc-qa__opcoes--tam' : '') + (o.cor ? ' rc-qa__opcoes--cor' : '') + '">';
      o.valores.forEach(function (val) {
        if (o.cor) {
          h += '<button type="button" class="rc-qa__op rc-qa__op--cor" data-rc-qa-op="' + o.i + '" data-valor="' + esc(val) +
            '" aria-label="' + esc(val) + '" title="' + esc(val) + '" style="--rc-cor:' + hexDe(val) + '"></button>';
          return;
        }
        h += '<button type="button" class="rc-qa__op" data-rc-qa-op="' + o.i + '" data-valor="' + esc(val) + '">' + esc(val) + '</button>';
      });
      h += '</div></div>';
    });
    var favOn = window.rcFav && window.rcFav.tem(p.handle);
    h += '<p class="rc-qa__erro" data-rc-qa-erro hidden></p>';
    h += '<div class="rc-qa__compra"><button type="button" class="rc-qa__add" data-rc-qa-add>Adicionar ao carrinho</button>' +
      '<button type="button" class="rc-qa__fav' + (favOn ? ' is-on' : '') + '" data-rc-qa-fav aria-label="Salvar nos favoritos">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.5s-7.5-4.6-7.5-10.2A4.3 4.3 0 0 1 12 7.6a4.3 4.3 0 0 1 7.5 2.7c0 5.6-7.5 10.2-7.5 10.2z"/></svg></button></div>';
    h += '</div>';

    if (p.description) {
      h += '<div class="rc-qa__faixa"></div><div class="rc-qa__sanfona"><details class="rc-qa__linha"><summary>' +
        '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 8.5a2.2 2.2 0 1 1 2.2-2.2"/><path d="M12 8.5v1.2L3 16.2a1 1 0 0 0 .6 1.8h16.8a1 1 0 0 0 .6-1.8L12 9.7"/></svg>' +
        '<span>Detalhes do produto</span><svg class="rc-qa__seta" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m6 9 6 6 6-6"/></svg></summary>' +
        '<div class="rc-qa__linha-corpo">' + p.description + '</div></details></div>';
    }
    h += '<div class="rc-qa__avs" data-rc-qa-avs></div>';
    corpo.innerHTML = h;
    corpo.scrollTop = 0;

    var fotos = corpo.querySelector('[data-rc-qa-fotos]');
    if (fotos) {
      fotos.addEventListener(
        'scroll',
        function () {
          var primeira = fotos.firstElementChild;
          if (!primeira) return;
          var n = Math.round(fotos.scrollLeft / (primeira.offsetWidth + 2));
          corpo.querySelectorAll('.rc-qa__ponto').forEach(function (pt, k) {
            pt.classList.toggle('is-on', k === n);
          });
        },
        { passive: true }
      );
    }
    atualizar(false);
    avaliacoes(p);
  }

  function dataBr(t) {
    var d = new Date(t);
    if (isNaN(d)) return '';
    return d.toLocaleDateString('pt-BR', { day: 'numeric', month: 'long', year: 'numeric' });
  }
  function avaliacoes(p) {
    var caixa = raiz.querySelector('[data-rc-qa-avs]');
    if (!caixa) return;
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(base + 'products/' + encodeURIComponent(p.handle) + '?section_id=rc-qa-dados', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.querySelector('[data-rc-qa-dados]');
        if (!el || !atual || atual.p.handle !== p.handle) return;
        var d = JSON.parse(el.textContent);
        var qt = parseInt(d.qt, 10) || 0;
        var nota = parseFloat(d.nota) || 0;
        var rs = d.reviews || [];
        if (!qt && !rs.length) return;
        var h = '<div class="rc-qa__faixa"></div><div class="rc-qa__av">';
        h += '<p class="rc-qa__av-tit">Avaliações</p>';
        if (qt) {
          h += '<div class="rc-qa__av-nota"><b>' + nota.toFixed(1).replace('.', ',') + '</b><span class="rc-qa__estrelas" style="--rc-p:' + Math.round((nota / 5) * 100) + '%" aria-hidden="true"></span></div>';
          h += '<p class="rc-qa__av-qt">(' + qt + (qt === 1 ? ' avaliação' : ' avaliações') + ')</p>';
        }
        h += '<div class="rc-qa__fit"><div class="rc-qa__fit-barra">';
        for (var n = 1; n <= 5; n++) h += '<i' + (n === (d.fit || 3) ? ' class="is-on"' : '') + '></i>';
        h += '</div><div class="rc-qa__fit-rot"><span>Pequena</span><span>Fiel ao tamanho</span><span>Grande</span></div></div>';
        if (rs.length) {
          h += '<p class="rc-qa__av-mostra">' + (d.loja ? 'Fotos de clientes em outras peças Roncador' : 'Mostrando ' + rs.length + ' de ' + qt + ' avaliações') + '</p><div class="rc-qa__av-trilho">';
          rs.forEach(function (r) {
            var pct = Math.round(((parseFloat(r.nota) || 5) / 5) * 100);
            h += '<div class="rc-qa__av-card"><div class="rc-qa__av-cab"><span class="rc-qa__estrelas" style="--rc-p:' + pct + '%" aria-hidden="true"></span>' +
              '<span class="rc-qa__av-data">' + esc(dataBr(r.data)) + '</span></div>' +
              '<p class="rc-qa__av-texto">' + esc(r.texto) + '</p>' +
              (r.foto ? '<img class="rc-qa__av-foto" src="' + (r.foto.indexOf('//') === 0 ? 'https:' + r.foto : r.foto) + '" alt="" width="64" height="64">' : '') +
              '<p class="rc-qa__av-autor">- ' + esc(r.autor) + '</p></div>';
          });
          h += '</div>';
        }
        h += '<a class="rc-qa__av-todas" href="' + esc(p.url) + '#rc-avaliacoes">Ver todas as avaliações</a></div>';
        caixa.innerHTML = h;
      })
      .catch(function () {});
  }

  function irParaFoto(v) {
    if (!v || !v.featured_image) return;
    var fotos = raiz.querySelector('[data-rc-qa-fotos]');
    if (!fotos) return;
    var n = (v.featured_image.position || 1) - 1;
    var alvo = fotos.children[n];
    if (alvo) fotos.scrollTo({ left: alvo.offsetLeft, behavior: 'smooth' });
  }

  function atualizar(mudouCor) {
    var corpo = raiz.querySelector('[data-rc-qa-corpo]');
    var p = atual.p;
    atual.ops.forEach(function (o) {
      var grupo = corpo.querySelector('[data-rc-qa-grupo="' + o.i + '"]');
      if (!grupo) return;
      var possiveis = variantesQueCombinam(atual.sel, o.i);
      grupo.querySelectorAll('[data-rc-qa-op]').forEach(function (b) {
        var val = b.getAttribute('data-valor');
        var tem = possiveis.some(function (v) {
          return v.options[o.i] === val && v.available;
        });
        var on = atual.sel[o.i] === val;
        b.classList.toggle('is-on', on);
        b.classList.toggle('is-off', !tem);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var rotulo = grupo.querySelector('[data-rc-qa-valor]');
      if (rotulo) rotulo.textContent = atual.sel[o.i] || '';
    });

    var v = varianteEscolhida();
    var ref = v || variantesQueCombinam(atual.sel, -1).filter(function (x) {
      return x.available;
    })[0] || p.variants[0];
    var venda = corpo.querySelector('[data-rc-qa-venda]');
    var de = corpo.querySelector('[data-rc-qa-de]');
    var promo = ref.compare_at_price && ref.compare_at_price > ref.price;
    venda.textContent = dinheiro(ref.price);
    venda.classList.toggle('is-normal', !promo);
    de.textContent = promo ? dinheiro(ref.compare_at_price) : '';
    if (mudouCor) irParaFoto(ref);

    var add = raiz.querySelector('[data-rc-qa-add]');
    var falta = atual.ops.filter(function (o) {
      return atual.sel[o.i] == null;
    })[0];
    add.disabled = false;
    add.classList.remove('is-espera');
    if (!falta && (!v || !v.available)) {
      add.textContent = 'Esgotado';
      add.disabled = true;
    } else {
      add.textContent = 'Adicionar ao carrinho';
    }
    raiz.querySelector('[data-rc-qa-erro]').hidden = true;
  }

  /* ---------- carrinho (mesmo caminho do botao da pagina do produto) ---------- */
  function adicionar(botao) {
    var v = varianteEscolhida();
    if (!v) {
      var falta = atual.ops.filter(function (o) {
        return atual.sel[o.i] == null;
      })[0];
      var grupo = falta && raiz.querySelector('[data-rc-qa-grupo="' + falta.i + '"]');
      if (grupo) {
        grupo.classList.remove('is-alerta');
        void grupo.offsetWidth;
        grupo.classList.add('is-alerta');
        grupo.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
      return;
    }
    var carrinho = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var erro = raiz.querySelector('[data-rc-qa-erro]');
    var dados = new FormData();
    dados.append('id', v.id);
    dados.append('quantity', 1);
    if (carrinho && carrinho.getSectionsToRender) {
      dados.append(
        'sections',
        carrinho.getSectionsToRender().map(function (s) {
          return s.id;
        })
      );
      dados.append('sections_url', window.location.pathname);
    }
    /* avisa a Shopify (analytics) que um produto foi para o carrinho */
    var SE = window.StandardEvents || {};
    var adiado = null;
    if (SE.CartLinesUpdateEvent) {
      adiado = SE.CartLinesUpdateEvent.createPromise();
      botao.dispatchEvent(
        new SE.CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: v.id, quantity: 1 }],
          promise: adiado.promise,
        })
      );
    }
    botao.classList.add('is-carregando');
    erro.hidden = true;
    var rota = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(rota, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: dados,
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (res) {
        botao.classList.remove('is-carregando');
        if (res.status) {
          erro.textContent = res.description || res.message || 'Não foi possível adicionar.';
          erro.hidden = false;
          if (adiado) adiado.reject(new Error(res.description || res.message));
          return;
        }
        if (adiado) {
          fetch(((window.routes && window.routes.cart_url) || '/cart') + '.json', { credentials: 'same-origin' })
            .then(function (r) {
              return r.json();
            })
            .then(function (c) {
              adiado.resolve({ cart: SE.CartLinesUpdateEvent.createCartFromAjaxResponse(c) });
            })
            .catch(function (e) {
              adiado.reject(e);
            });
        }
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: v.id, cartData: res });
        }
        fechar();
        if (!carrinho || !carrinho.renderContents) {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        if (carrinho.setActiveElement && origem) carrinho.setActiveElement(origem);
        carrinho.classList.remove('is-empty');
        setTimeout(function () {
          carrinho.renderContents(res);
        }, 250);
      })
      .catch(function (e) {
        botao.classList.remove('is-carregando');
        erro.textContent = 'Sem conexão. Tente de novo.';
        erro.hidden = false;
        if (adiado) adiado.reject(e);
      });
  }

  /* ---------- cliques ---------- */
  function clique(e) {
    var el;
    if ((el = e.target.closest('[data-rc-qa-fecha]'))) {
      fechar();
      return;
    }
    if ((el = e.target.closest('[data-rc-qa-op]'))) {
      if (!atual) return;
      var i = Number(el.getAttribute('data-rc-qa-op'));
      var o = atual.ops.filter(function (x) {
        return x.i === i;
      })[0];
      atual.sel[i] = el.getAttribute('data-valor');
      /* trocou a cor e o tamanho nao existe nela: limpa o tamanho */
      atual.ops.forEach(function (x) {
        if (x.i === i || atual.sel[x.i] == null) return;
        var ok = variantesQueCombinam(atual.sel, -1).some(function (v) {
          return v.available;
        });
        if (!ok && x.tam) atual.sel[x.i] = null;
      });
      var grupo = el.closest('[data-rc-qa-grupo]');
      if (grupo) grupo.classList.remove('is-alerta');
      atualizar(o && !o.tam);
      return;
    }
    if ((el = e.target.closest('[data-rc-qa-tab-fecha]'))) {
      var tf = raiz.querySelector('[data-rc-qa-tab]');
      tf.classList.remove('is-aberta');
      setTimeout(function () { tf.hidden = true; }, 380);
      return;
    }
    if ((el = e.target.closest('[data-rc-qa-tabela]'))) {
      var tab = raiz.querySelector('[data-rc-qa-tab]');
      var tc = raiz.querySelector('[data-rc-qa-tab-corpo]');
      var url = el.getAttribute('data-rc-qa-tabela');
      tab.hidden = false;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { tab.classList.add('is-aberta'); });
      });
      tc.scrollTop = 0;
      if (tc.getAttribute('data-url') === url) return;
      tc.innerHTML = '<div class="rc-qa__carregando"></div>';
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var c = doc.querySelector('#MainContent .rte') || doc.querySelector('#MainContent');
          var t = doc.querySelector('#MainContent h1');
          if (t) raiz.querySelector('[data-rc-qa-tab] .rc-qa__topo-tit').textContent = t.textContent.trim();
          tc.innerHTML = c ? c.innerHTML : '';
          tc.querySelectorAll('script').forEach(function (x) { x.remove(); });
          tc.setAttribute('data-url', url);
        })
        .catch(function () {
          tc.innerHTML = '<p class="rc-qa__erro">Não deu para abrir a tabela. Tente de novo.</p>';
        });
      return;
    }
    if ((el = e.target.closest('[data-rc-qa-fav]'))) {
      if (!atual || !window.rcFav) return;
      var pp = atual.p;
      if (window.rcFav.tem(pp.handle)) {
        window.rcFav.remover(pp.handle);
        el.classList.remove('is-on');
      } else {
        var vr = varianteEscolhida() || pp.variants[0];
        var tamOp = atual.ops.filter(function (o) { return o.tam; })[0];
        window.rcFav.salvar({
          h: pp.handle, t: pp.title, u: pp.url, f: pp.images && pp.images[0] ? foto(pp.images[0], 360) : '',
          p: vr.price, d: vr.compare_at_price || 0, s: tamOp ? atual.sel[tamOp.i] || '' : ''
        });
        el.classList.add('is-on');
      }
      return;
    }
    if ((el = e.target.closest('[data-rc-qa-add]'))) {
      if (atual) adicionar(el);
    }
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-rc-qa]');
    if (!b) return;
    origem = b;
    e.preventDefault();
    e.stopPropagation();
    var handle = b.getAttribute('data-rc-qa');
    var nota = parseFloat(b.getAttribute('data-rc-nota')) || 0;
    var qt = parseInt(b.getAttribute('data-rc-qt'), 10) || 0;
    montar();
    atual = null;
    raiz.querySelector('[data-rc-qa-corpo]').innerHTML = '<div class="rc-qa__carregando" aria-label="Carregando"></div>';
    abrir();
    buscar(handle)
      .then(function (p) {
        desenhar(p, nota, qt);
      })
      .catch(function () {
        fechar();
        window.location = b.closest('.grid__item').querySelector('a[href*="/products/"]').href;
      });
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') fechar();
  });
  /* troca de pagina sem recarregar: fecha a folha */
  document.addEventListener('rc:pagina-trocada', fechar);
})();
